<div class="container" [chart]="chart"></div>